// What a recording idea has in it: which part of the Rhythm Graph it joins, and the TrueChops
// instruments it's filed under when no notation says.
export const RECORDING_SOUNDS = { drums: "Drums", snare: "Snare drum", percussion: "Percussion", piano: "Piano", song: "A full song", other: "Something else" };
export const SOUND_INSTRUMENTS = { drums: ["drumset"], snare: ["snare"], percussion: [], piano: ["piano"], song: [], other: [] };
